import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import UserContext from '../../context/user-context';
import { getLoginUrl } from '../../services/login/loginService';
import Error from '../../components/common/Error/Error';
import styles from './Login.module.css';
import Spinner from '../../components/common/Spinner/Spinner';

function Login() {
  const { t } = useTranslation();
  const [loginUrl, setLoginUrl] = useState<string>();
  const [loginUrlError, setLoginUrlError] = useState(false);
  const navigate = useNavigate();
  const userCtx = useContext(UserContext);

  useEffect(() => {
    const getUrl = async () => {
      try {
        const response = await getLoginUrl();
        setLoginUrl(`${response.login_path}`);
      } catch (err) {
        setLoginUrlError(true);
        userCtx.setIsLoggedIn(true);
        navigate('/');
      }
    };
    getUrl();

  }, []);

  useEffect(() => {
    if (!loginUrlError && loginUrl) {
      window.location.href = loginUrl;
    }
  }, [loginUrl, loginUrlError]);

  return (
    <div className={styles.container}>
      {loginUrlError && <Error messageText={t('login.technicalError')} />}
      {!loginUrl && <Spinner />}
    </div>
  );
}

export default Login;
